/* eslint-disable camelcase */

export default class CampaignAvailability {
	constructor({
		valid,
		remaining_contacts,
		extra_contacts
	} = {}) {
		this._valid= valid;
		this._remaining_contacts = remaining_contacts;
		this._extra_contacts = extra_contacts;
	}

	getKey(){
		return '';
	}

	isValid() {
		return this._valid;
	}

	getRemainingContacts(){
		return this._remaining_contacts;
	}

	getExtraContacts(){
		return this._extra_contacts;
	}
}